export default __webpack_public_path__ + "static/media/flower.f9043f1e.png";